import '../../../polyfills';
import WebpackerReact from 'webpacker-react';

import { ProductBucket } from '../../../ProductBucket';

WebpackerReact.setup({ ProductBucket });
